/**
 * @author gyb(mocheer)
 * @email `mocheer@foxmail.com`  
 * @since 2017.6.15
 */
let {
  TileLayer,
  latLng: toLatLng,
  point: toPoint,
  Util
} = L,
defaultWmtsParams = {
  service: 'WMTS',
  request: 'GetTile',
  version: '1.0.0',
  layer: '',
  style: '', // default
  tilematrixSet: '', // TileMatrixSet0
  format: 'image/jpeg'
}
/**
 * 
 */
export default TileLayer.extend({
  /**
   * 
   * @param {*} url 
   * @param {*} options
   */
  initialize(url, options) {
    this._url = url;
    let wmtsParams = T.merge({}, defaultWmtsParams);
    let tileSize = options.tileSize || this.options.tileSize;
    let {
      detectRetina,
      matrixIds,
      zoomOffset
    } = options;
    wmtsParams.width = wmtsParams.height = tileSize * ((detectRetina && L.Browser.retina) ? 2 : 1);
    T.each(options, (val, key) => {
      if (key !== "matrixIds" && key !== 'zoomOffset') {
        wmtsParams[key] = val;
      }
    })
    this.zoomOffset = zoomOffset || 0;
    this.wmtsParams = wmtsParams;
    this.matrixIds = (typeof matrixIds === 'string' || !matrixIds) ? this.getMatrix(matrixIds) : matrixIds;

    L.setOptions(this, options);
  },
  /**
   * 
   * @param {*} tilePoint 
   */
  getTileUrl(tilePoint) {
    let {
      _map: map,
      options,
      _url,
      matrixIds,
      wmtsParams
    } = this, {
      crs
    } = map.options, {
        tileSize
      } = options,
      nwPoint = tilePoint.multiplyBy(tileSize);
    // +/-1 in order to be on the tile
    nwPoint.x += 1;
    nwPoint.y -= 1;
    let zoom = this._tileZoom;
    let sePoint = nwPoint.add(toPoint(tileSize, tileSize));
    let nw = crs.project(map.unproject(nwPoint, zoom));
    let se = crs.project(map.unproject(sePoint, zoom));
    let tilewidth = se.x - nw.x;
    let matrixZoom = matrixIds[zoom];
    let ident = matrixZoom.identifier;
    let X0 = matrixZoom.topLeftCorner.lng;
    let Y0 = matrixZoom.topLeftCorner.lat;
    let tilecol = Math.floor((nw.x - X0) / tilewidth);
    let tilerow = -Math.floor((nw.y - Y0) / tilewidth);
    let url = Util.template(_url, {
      s: this._getSubdomain(tilePoint)
    });
    return url + Util.getParamString(wmtsParams, url) + "&tilematrix=" + ident + "&tilerow=" + tilerow + "&tilecol=" + tilecol;
  },
  /**
   * 
   * @param {*} params 
   * @param {*} noRedraw 
   */
  setParams(params, noRedraw) {
    Util.extend(this.wmtsParams, params);
    if (!noRedraw) {
      this.redraw();
    }
    return this;
  },
  /**
   * matrix
   */
  getMatrix(crs) {
    let matrixIds = [];
    let loc;
    let i = 0;
    switch (crs) {
      case 'EPSG4326':
        i = this.zoomOffset;
        loc = toLatLng(90, -180)
        break;
      default:
        loc = toLatLng(20037508.3428, -20037508.3428)
        break;
    }
    for (; i < 22; i++) {
      matrixIds.push({
        identifier: '' + i,
        topLeftCorner: loc
      })
    }
    return matrixIds;
  }
})



// WEBPACK FOOTER //
// ./src/layer/WMTSLayer.js